enum SpRegionEnum {
    InnerCity = 'INNER_CITY',
    Metro = 'METRO',
    NonMetro = 'NON_METRO',
}

export default SpRegionEnum;
